import { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { mapPendingPaymentToFormValues } from '../utils/aiTool/formRestoreMappers'
import {
  getPendingAiToolPayment,
  isAiToolPaymentCancelled,
} from '../utils/aiTool/payment'

/**
 * Handles payment return query params on AI tool form pages:
 * - Cancel/back from Razorpay: restores form inputs, no error banner
 * - Actual payment failure: shows error banner and restores form inputs for retry
 */
export function useAiToolPaymentError(toolType, onRestoreForm) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [paymentError, setPaymentError] = useState('')

  useEffect(() => {
    const cancelled = isAiToolPaymentCancelled(searchParams)
    const errorMessage = searchParams.get('paymentError')

    if (!cancelled && !errorMessage) return

    const paymentId = searchParams.get('paymentId')

    if (paymentId && toolType && onRestoreForm) {
      const pending = getPendingAiToolPayment(paymentId)
      if (pending?.toolType === toolType) {
        const restored = mapPendingPaymentToFormValues(toolType, pending)
        if (restored) {
          onRestoreForm(restored)
        }
      }
    }

    if (errorMessage) {
      setPaymentError(errorMessage)
    }

    const nextParams = new URLSearchParams(searchParams)
    nextParams.delete('paymentCancelled')
    nextParams.delete('paymentError')
    nextParams.delete('paymentSuccess')
    nextParams.delete('paymentId')
    setSearchParams(nextParams, { replace: true })
  }, [toolType, onRestoreForm, searchParams, setSearchParams])

  const clearPaymentError = useCallback(() => {
    setPaymentError('')
  }, [])

  return { paymentError, clearPaymentError }
}
